import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

const Navbar = ({ scrollToContact }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleContactClick = () => {
        setIsOpen(false);
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => scrollToContact(), 100); // wait for Home to load
        } else {
            scrollToContact();
        }
    };

    const getLinkClass = ({ isActive }) =>
        `relative text-gray-700 hover:text-blue-600 font-medium transition duration-200 ${isActive ? 'text-blue-600 after:absolute after:left-0 after:right-0 after:bottom-[-4px] after:h-[2px] after:bg-blue-600' : ''}`;

    return (
        <nav className="bg-white shadow-sm sticky top-0 z-50">
            <div className="mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">

                    <NavLink to="/" className="flex-shrink-0 text-blue-600 font-bold text-xl">
                        Besto HRMS
                    </NavLink>

                    <div className="hidden md:flex items-center gap-[32px] ml-auto">
                        {/* Text buttons */}
                        <div className="flex items-center gap-[32px]">
                            <button onClick={handleContactClick} className="text-gray-700 hover:text-blue-600 font-medium transition duration-200 lg:px-[16px] lg:py-[10px]">
                                Features
                            </button>
                            <button onClick={handleContactClick} className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                                Pricing
                            </button>
                            <button onClick={handleContactClick} className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                                Contact Us
                            </button>
                        </div>

                        {/* Auth buttons */}
                        <div className="flex items-center gap-[16px]">
                            <NavLink to="/register" className="px-4 py-2 bg-[#006AFF] border border-blue-600 text-[#fff] rounded-md transition">
                                Register
                            </NavLink>
                        </div>
                    </div>


                    <div className="md:hidden">
                        <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 focus:outline-none">
                            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {isOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className="md:hidden px-4 pb-4 space-y-3">
                    {/* <NavLink to="/features" className="block text-gray-700">Terms and Condition</NavLink>
                    <NavLink to="/pricing" className="block text-gray-700">Privacy & Policy</NavLink> */}
                    <button onClick={handleContactClick} className="block text-gray-700 mb-4">Contact Us</button>
                    <NavLink to="/register" className="register px-4 py-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition mt-4">
                        Register
                    </NavLink>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
